// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  overflow: hidden;
}
body {
  margin: 0;
  padding: 0;
  /* height: 100%; */
  color: black;
  transition: color 0.3s ease, background-color 0.3s ease;
  height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}
#root {
  width: 100%;
  height: 100%;
}
* {
  /* 确保任何内边距和边框都包含在高度计算中 */
  box-sizing: border-box;
}
/* 整体滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 宽度 */
  height: 6px;
  /* 高度（用于水平滚动条） */
}
/* 滚动条轨道 */
::-webkit-scrollbar-track {
  /* background: #f4f4f4; 轨道颜色 */
  border-radius: 6px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #dbdbdb;
  /* 滑块颜色 */
  border-radius: 3px;
}
/* 滑块在悬停时 */
::-webkit-scrollbar-thumb:hover {
  background: #dbdbdb;
}
/* @font-face {
    font-family: 'Allura';
    src: url('../fonts/Allura-Regular.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'Arizonia';
    src: url('../fonts/Arizonia-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'Italianno';
    src: url('../fonts/Italianno-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'LoveLight';
    src: url('../fonts/LoveLight-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'Norican';
    src: url('../fonts/Norican-Regular.woff2') format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'PinyonScript';
    src: url('../fonts/PinyonScript-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'Qwigley';
    src: url('../fonts/Qwigley-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  } */
`, "",{"version":3,"sources":["webpack://./src/pc/index.less"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AAEE;EACE,SAAA;EACA,UAAA;EAAF,kBAAkB;EAEhB,YAAA;EACA,uDAAA;EAEA,aAAA;EAEA,8JAAA;EAGA,mCAAA;EACA,kCAAA;AAJJ;AAOE;EACE,+EAAA;AALJ;AASE;EACE,WAAA;EACA,YAAA;AAPJ;AAUE;EARA,wBAAwB;EAUtB,sBAAA;AARJ;AACA,YAAY;AAWV;EACE,UAAA;EATF,OAAO;EAWL,WAAA;EATF,gBAAgB;AAClB;AACA,UAAU;AAYR;EAVA,8BAA8B;EAY5B,kBAAA;AAVJ;AACA,UAAU;AAaR;EACE,mBAAA;EAXF,SAAS;EAaP,kBAAA;AAXJ;AACA,WAAW;AAcT;EACE,mBAAA;AAZJ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA+CK","sourcesContent":["html {\n    overflow: hidden;\n  }\n  \n  body {\n    margin: 0;\n    padding: 0;\n    /* height: 100%; */\n    color: black;\n    transition: color 0.3s ease, background-color 0.3s ease;\n  \n    height: 100vh;\n  \n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n      sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  \n  code {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n      monospace;\n  }\n  \n  #root {\n    width: 100%;\n    height: 100%;\n  }\n  \n  * {\n    /* 确保任何内边距和边框都包含在高度计算中 */\n    box-sizing: border-box;\n  }\n  \n  /* 整体滚动条样式 */\n  ::-webkit-scrollbar {\n    width: 6px;\n    /* 宽度 */\n    height: 6px;\n    /* 高度（用于水平滚动条） */\n  }\n  \n  /* 滚动条轨道 */\n  ::-webkit-scrollbar-track {\n    /* background: #f4f4f4; 轨道颜色 */\n    border-radius: 6px;\n  }\n  \n  /* 滚动条滑块 */\n  ::-webkit-scrollbar-thumb {\n    background: #dbdbdb;\n    /* 滑块颜色 */\n    border-radius: 3px;\n  }\n  \n  /* 滑块在悬停时 */\n  ::-webkit-scrollbar-thumb:hover {\n    background: #dbdbdb;\n  }\n  \n  /* @font-face {\n    font-family: 'Allura';\n    src: url('../fonts/Allura-Regular.woff2') format('woff2');\n    font-weight: normal;\n    font-style: normal;\n  }\n  \n  @font-face {\n    font-family: 'Arizonia';\n    src: url('../fonts/Arizonia-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n  }\n  \n  @font-face {\n    font-family: 'Italianno';\n    src: url('../fonts/Italianno-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n  }\n  \n  @font-face {\n    font-family: 'LoveLight';\n    src: url('../fonts/LoveLight-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n  }\n  \n  @font-face {\n    font-family: 'Norican';\n    src: url('../fonts/Norican-Regular.woff2') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n  }\n  \n  @font-face {\n    font-family: 'PinyonScript';\n    src: url('../fonts/PinyonScript-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n  }\n  \n  @font-face {\n    font-family: 'Qwigley';\n    src: url('../fonts/Qwigley-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n  } */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
